import React from 'react';
import ReactDOM from 'react-dom';
const { Icon, Card, Button } = window;

/* Select dos filtros — FORA do componente de propósito: se ficar dentro, o React
   recria o tipo a cada render e remonta o <select>, fazendo o filtro "não obedecer". */
const Sel = ({ value, onChange, children, w }) => (
  <div style={{ position: 'relative', display: 'inline-block' }}>
    <select value={value} onChange={e => onChange(e.target.value)} style={{ appearance: 'none', padding: '9px 32px 9px 13px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface)', color: 'var(--text-strong)', fontWeight: 600, fontSize: 13.5, cursor: 'pointer', minWidth: w || 'auto' }}>{children}</select>
    <Icon name="chevronD" size={14} style={{ position: 'absolute', right: 11, top: 11, pointerEvents: 'none', color: 'var(--text-muted)' }} />
  </div>
);
/* ============================================================
   BOOKER — Tela: Empresas Booker (cadastro + vínculo com contratos)
   ============================================================ */
var { useState, useEffect, useMemo } = React;

function Empresas({ onNavigate }) {
  const [lista, setLista] = useState([]);
  const [contratos, setContratos] = useState([]); // p/ o modal de vínculo manual
  const [estado, setEstado] = useState('carregando'); // carregando | ok | erro
  const [erro, setErro] = useState('');
  const [busca, setBusca] = useState('');
  const [fTipo, setFTipo] = useState('all');
  const [fGrupo, setFGrupo] = useState('all');
  const [fContrato, setFContrato] = useState('all');
  const [form, setForm] = useState(null); // {} = nova empresa | empresa = editar
  const [vincular, setVincular] = useState(null); // empresa a vincular manualmente
  const [sincronizando, setSincronizando] = useState(false);
  const [exportando, setExportando] = useState(false);
  const [pastaUrl, setPastaUrl] = useState('');
  const [arquivoSp, setArquivoSp] = useState('');
  const podeEditar = window.podeEditar ? window.podeEditar() : true;

  // Puxa a planilha-mestre direto do SharePoint (o robô também faz isso sozinho).
  async function sincronizar() {
    setSincronizando(true);
    try {
      const s = await window.Api.apiEmpresasSincronizar();
      window.avisar(`Sincronizado de "${s.arquivo}": ${s.inseridos} nova(s) · ${s.atualizados} atualizada(s) · ${s.removidos || 0} removida(s). O banco reflete a planilha.`);
      carregar();
    } catch (e) { window.avisar(e.message); }
    finally { setSincronizando(false); }
  }

  // Exporta a tabela de empresas em .xlsx, respeitando os filtros ativos:
  // manda só os ids das linhas visíveis (`filtradas`) pro backend recortar.
  async function exportar() {
    setExportando(true);
    try { await window.Api.apiEmpresasExport(filtradas.map(e => e.id)); }
    catch (e) { window.avisar(e.message); }
    finally { setExportando(false); }
  }

  async function carregar() {
    setEstado('carregando'); setErro('');
    try {
      const [emp, dados] = await Promise.all([
        window.Api.apiEmpresasList(),
        window.Api.apiContractsData().catch(() => ({ clientes: [], contratos: [] })),
      ]);
      const razaoDe = {};
      (dados.clientes || []).forEach(c => { razaoDe[c.id] = c.razao; });
      setContratos((dados.contratos || []).map(k => ({ dbId: k.dbId, codigo: k.codigo, razao: razaoDe[k.clienteId] || '—' })));
      setLista(emp); setEstado('ok');
    } catch (e) { setErro(e.message); setEstado('erro'); }
  }
  useEffect(() => { carregar(); }, []);

  async function desvincular(e) {
    if (!await window.confirmar(`Desvincular "${e.razao}" do contrato ${e.contrato.codigo}?`)) return;
    try { await window.Api.apiEmpresaVincular(e.id, null); carregar(); }
    catch (err) { window.avisar(err.message); }
  }
  useEffect(() => {
    window.Api.apiEmpresasSharepoint()
      .then(d => { setPastaUrl((d && d.pastaUrl) || ''); setArquivoSp((d && d.arquivo) || ''); })
      .catch(() => {});
  }, []);

  // "tem contrato" = o mesmo que a tela mostra na coluna Contrato (casados por
  // CNPJ + vínculo manual). Antes usava a flag possuiContrato, que divergia.
  const temContrato = (e) => !!(e.contratos && e.contratos.length);
  const gruposTodos = useMemo(() => [...new Set(lista.map(e => (e.grupo || '').trim()).filter(Boolean))].sort(), [lista]);
  const stats = useMemo(() => ({
    total: lista.length,
    com: lista.filter(temContrato).length,
    sem: lista.filter(e => !temContrato(e)).length,
    grupos: gruposTodos.length,
  }), [lista, gruposTodos]);

  // Empresas que passam por TODOS os filtros MENOS o de grupo. É daqui que saem
  // as opções do dropdown de grupo — assim ele só oferece grupos que realmente
  // existem no recorte atual (ex.: filtrando "Sem contrato", só grupos sem contrato).
  const semFiltroGrupo = useMemo(() => {
    const q = busca.trim().toLowerCase();
    return lista.filter(e => {
      if (fTipo !== 'all' && (e.tipo || '').trim().toUpperCase() !== fTipo) return false;
      if (fContrato === 'sim' && !temContrato(e)) return false;
      if (fContrato === 'nao' && temContrato(e)) return false;
      if (q && !((e.razao || '').toLowerCase().includes(q) || (e.cnpj || '').includes(q) || (e.grupo || '').toLowerCase().includes(q))) return false;
      return true;
    });
  }, [lista, busca, fTipo, fContrato]);

  const grupos = useMemo(() => [...new Set(semFiltroGrupo.map(e => (e.grupo || '').trim()).filter(Boolean))].sort(), [semFiltroGrupo]);

  // Se o grupo escolhido deixou de existir no recorte, volta para "todos" —
  // senão a lista ficaria vazia sem o usuário entender o porquê.
  useEffect(() => {
    if (fGrupo !== 'all' && !grupos.includes(fGrupo)) setFGrupo('all');
  }, [grupos, fGrupo]);

  const filtradas = useMemo(
    () => (fGrupo === 'all' ? semFiltroGrupo : semFiltroGrupo.filter(e => (e.grupo || '').trim() === fGrupo)),
    [semFiltroGrupo, fGrupo],
  );

  return (
    <div style={{ animation: 'fadeUp .4s ease both' }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-end', flexWrap: 'wrap', gap: 16, marginBottom: 20 }}>
        <div>
          <h1 style={{ margin: 0, fontSize: 26, fontWeight: 800, color: 'var(--text-strong)', letterSpacing: '-.02em' }}>Empresas Booker</h1>
          <p style={{ margin: '5px 0 0', color: 'var(--text-muted)', fontSize: 14 }}>Espelho da planilha-mestre no SharePoint · vínculo com os contratos pelo CNPJ</p>
          {pastaUrl && (
            <a href={pastaUrl} target="_blank" rel="noopener noreferrer"
              style={{ display: 'inline-flex', alignItems: 'center', gap: 6, marginTop: 8, fontSize: 13, fontWeight: 700, color: 'var(--booker-orange)', textDecoration: 'none' }}>
              <Icon name="external" size={14} /> Abrir a pasta EMPRESAS BOOKER no SharePoint{arquivoSp ? ` · ${arquivoSp}` : ''}
            </a>
          )}
        </div>
        <div style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <Button variant="default" icon="download" onClick={exportando ? undefined : exportar} title="Baixa a tabela de empresas em Excel (.xlsx)">{exportando ? 'Exportando…' : 'Exportar tabela'}</Button>
          {podeEditar && <Button variant="accent" icon="refresh" onClick={sincronizando ? undefined : sincronizar} title="Puxa a planilha-mestre da pasta EMPRESAS BOOKER no SharePoint">{sincronizando ? 'Sincronizando…' : 'Sincronizar do SharePoint'}</Button>}
        </div>
      </div>

      {estado === 'ok' && (
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4,1fr)', gap: 14, marginBottom: 16 }}>
          <Mini icon="building" tone="var(--text-strong)" label="Empresas" value={stats.total} />
          <Mini icon="check" tone="var(--ok)" label="Com contrato" value={stats.com} />
          <Mini icon="alert" tone="var(--booker-orange)" label="Sem contrato" value={stats.sem} />
          <Mini icon="folder" tone="var(--info)" label="Grupos" value={stats.grupos} />
        </div>
      )}

      {estado === 'ok' && (
        <Card pad={14} style={{ marginBottom: 16 }}>
          <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap', alignItems: 'center' }}>
            <div style={{ position: 'relative', flex: 1, minWidth: 220 }}>
              <Icon name="search" size={17} style={{ position: 'absolute', left: 12, top: 11, color: 'var(--text-muted)' }} />
              <input value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por razão social, CNPJ ou grupo…" style={{ width: '100%', padding: '10px 12px 10px 38px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 14, outline: 'none' }} />
            </div>
            <Sel value={fContrato} onChange={setFContrato}>
              <option value="all">Contrato: todos</option><option value="sim">Com contrato</option><option value="nao">Sem contrato</option>
            </Sel>
            <Sel value={fTipo} onChange={setFTipo}>
              <option value="all">Tipo: todos</option><option value="CONTABILIDADE">Contabilidade</option><option value="CONSULTORIA">Consultoria</option>
            </Sel>
            <Sel value={fGrupo} onChange={setFGrupo} w={150}>
              <option value="all">Grupo: todos ({grupos.length})</option>
              {grupos.map(g => <option key={g} value={g}>{g}</option>)}
            </Sel>
          </div>
        </Card>
      )}

      {estado === 'carregando' && <Card pad={40} style={{ textAlign: 'center', color: 'var(--text-muted)' }}>Carregando empresas…</Card>}
      {estado === 'erro' && (
        <Card pad={24} style={{ display: 'flex', alignItems: 'center', gap: 14 }}>
          <span style={{ width: 42, height: 42, borderRadius: 11, background: 'var(--danger-bg)', color: 'var(--danger)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name="alert" size={20} /></span>
          <div style={{ flex: 1 }}><div style={{ fontSize: 14.5, fontWeight: 700, color: 'var(--text-strong)' }}>Não foi possível carregar</div><div style={{ fontSize: 13, color: 'var(--text-muted)' }}>{erro}</div></div>
          <Button variant="default" onClick={carregar}>Tentar de novo</Button>
        </Card>
      )}

      {estado === 'ok' && (
        <Card pad={0} style={{ overflow: 'hidden' }}>
          <div style={{ padding: '12px 18px', borderBottom: '1px solid var(--border)', fontSize: 12.5, color: 'var(--text-muted)', fontWeight: 600 }}>{filtradas.length} de {lista.length} empresas</div>
          <div style={{ overflowX: 'auto', maxHeight: '60vh', overflowY: 'auto' }}>
            <table style={{ width: '100%', borderCollapse: 'collapse', minWidth: 880 }}>
              <thead><tr style={{ position: 'sticky', top: 0, background: 'var(--surface)', zIndex: 1 }}>
                {['Razão social', 'Grupo', 'CNPJ', 'Contrato vinculado', ''].map((h, i) => (
                  <th key={i} style={{ textAlign: i >= 3 ? (i === 4 ? 'right' : 'left') : 'left', padding: '12px 16px', fontSize: 11.5, fontWeight: 700, color: 'var(--text-muted)', textTransform: 'uppercase', letterSpacing: '.05em', borderBottom: '1px solid var(--border)', whiteSpace: 'nowrap' }}>{h}</th>
                ))}
              </tr></thead>
              <tbody>
                {filtradas.map((e) => (
                  <tr key={e.id} style={{ borderTop: '1px solid var(--border)' }}>
                    <td style={{ padding: '11px 16px', fontSize: 13, fontWeight: 600, color: 'var(--text-strong)' }}>{e.razao || '—'}<div style={{ fontSize: 11, color: 'var(--text-faint)', fontWeight: 500 }}>{e.tipo === 'CONTABILIDADE' ? 'Contabilidade' : 'Consultoria'}</div></td>
                    <td style={{ padding: '11px 16px', fontSize: 12.5, color: 'var(--text)' }}>
                      {e.grupo || '—'}
                      {e.papel && <span style={{ marginLeft: 6, fontSize: 9.5, fontWeight: 800, color: e.papel === 'matriz' ? 'var(--booker-orange)' : 'var(--text-faint)', background: e.papel === 'matriz' ? 'var(--warn-bg)' : 'var(--surface-inset)', padding: '1px 6px', borderRadius: 4, textTransform: 'uppercase' }}>{e.papel}</span>}
                    </td>
                    <td style={{ padding: '11px 16px', fontSize: 12.5 }} className="mono">{e.cnpj || '—'}</td>
                    <td style={{ padding: '11px 16px' }}>
                      {e.contratos && e.contratos.length ? (
                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: 5, alignItems: 'center' }}>
                          {e.contratos.map(ct => (
                            <button key={ct.dbId} onClick={() => onNavigate('detalhe', ct.id)} title={ct.razao || ct.codigo}
                              style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11.5, fontWeight: 800, color: 'var(--ok)', background: 'var(--ok-bg)', padding: '3px 9px', borderRadius: 99, border: 'none', cursor: 'pointer' }}>
                              <Icon name="check" size={12} /> {ct.codigo}
                            </button>
                          ))}
                          {e.contratos.length > 1 && <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--text-muted)' }}>{e.contratos.length} contratos</span>}
                          {e.origem === 'manual' && <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--info)' }}>vínculo manual</span>}
                        </div>
                      ) : (
                        <span style={{ fontSize: 11.5, fontWeight: 700, color: 'var(--text-faint)' }}>—</span>
                      )}
                    </td>
                    <td style={{ padding: '11px 16px', textAlign: 'right', whiteSpace: 'nowrap' }}>
                      <span style={{ display: 'inline-flex', gap: 4, alignItems: 'center' }}>
                        {e.protegido && <span title="Cadastro/edição manual — protegido da reimportação" style={{ fontSize: 9.5, fontWeight: 800, color: 'var(--info)', background: 'var(--info-bg)', padding: '1px 6px', borderRadius: 4 }}>🔒</span>}
                        {podeEditar && <Button size="sm" variant="ghost" icon="edit" onClick={() => setForm(e)} title="Editar empresa">Editar</Button>}
                        {podeEditar && (e.contrato
                          ? <Button size="sm" variant="ghost" icon="trash" onClick={() => desvincular(e)} title="Desvincular contrato manual">Desvincular</Button>
                          : <Button size="sm" variant="default" icon="link" onClick={() => setVincular(e)} title="Vincular manualmente a um contrato (ex.: filial nova coberta pelo contrato)">Vincular</Button>)}
                      </span>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
            {!filtradas.length && <div style={{ padding: 40, textAlign: 'center', color: 'var(--text-muted)' }}>Nenhuma empresa para os filtros.</div>}
          </div>
        </Card>
      )}

      {form && <EmpresaFormModal empresa={form} grupos={grupos} onClose={() => setForm(null)} onSalvo={() => { setForm(null); carregar(); }} />}
      {vincular && <VincularModal empresa={vincular} contratos={contratos} empresas={lista} onClose={() => setVincular(null)} onVinculado={() => { setVincular(null); carregar(); }} />}
    </div>
  );
}

function EmpresaFormModal({ empresa, grupos, onClose, onSalvo }) {
  const editar = !!(empresa && empresa.id);
  const [tipo, setTipo] = useState(empresa.tipo || 'CONTABILIDADE');
  const [grupo, setGrupo] = useState(empresa.grupo || '');
  const [cnpj, setCnpj] = useState(empresa.cnpj || '');
  const [razao, setRazao] = useState(empresa.razao || '');
  const [salvando, setSalvando] = useState(false);
  const [erro, setErro] = useState('');

  async function salvar() {
    setErro('');
    if (!editar && cnpj.replace(/\D/g, '').length < 11) { setErro('Informe um CNPJ/CPF válido.'); return; }
    setSalvando(true);
    try {
      if (editar) await window.Api.apiEmpresaEditar(empresa.id, { tipo, grupo, razao_social: razao });
      else await window.Api.apiEmpresaCriar({ cnpj, tipo, grupo, razao_social: razao });
      onSalvo();
    } catch (e) { setErro(e.message); setSalvando(false); }
  }

  const campo = { width: '100%', padding: '11px 13px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 14, outline: 'none' };
  const Label = ({ children }) => <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', margin: '14px 0 6px' }}>{children}</label>;

  return ReactDOM.createPortal((
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 480, maxHeight: '88vh', overflowY: 'auto', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Icon name={editar ? 'edit' : 'plus'} size={19} style={{ color: 'var(--booker-orange)' }} />
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>{editar ? 'Editar empresa' : 'Nova empresa'}</h3>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4, cursor: 'pointer' }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: 22 }}>
          <Label>Tipo</Label>
          <select value={tipo} onChange={e => setTipo(e.target.value)} style={campo}>
            <option value="CONTABILIDADE">Contabilidade</option>
            <option value="CONSULTORIA">Consultoria</option>
          </select>

          <Label>Grupo de empresas</Label>
          <input list="grupos-existentes" value={grupo} onChange={e => setGrupo(e.target.value)} placeholder="Escolha um existente ou digite um novo" style={campo} />
          <datalist id="grupos-existentes">{grupos.map(g => <option key={g} value={g} />)}</datalist>
          {grupo && !grupos.includes(grupo) && <div style={{ fontSize: 11.5, color: 'var(--ok)', marginTop: 5 }}>✚ novo grupo "{grupo}"</div>}

          <Label>CNPJ / CPF</Label>
          <input value={cnpj} onChange={e => setCnpj(e.target.value)} disabled={editar} placeholder="00.000.000/0000-00" style={{ ...campo, opacity: editar ? 0.6 : 1 }} className="mono" />
          {editar && <div style={{ fontSize: 11, color: 'var(--text-muted)', marginTop: 5 }}>O CNPJ é a chave da empresa e não pode ser alterado.</div>}

          <Label>Razão social</Label>
          <input value={razao} onChange={e => setRazao(e.target.value)} placeholder="Razão social da empresa" style={campo} />

          <div style={{ marginTop: 14, fontSize: 11.5, color: 'var(--text-muted)', background: 'var(--surface-inset)', padding: '9px 12px', borderRadius: 'var(--r-sm)' }}>
            ℹ Papel (matriz/filial) e vínculo de contrato são automáticos pelo CNPJ. 🔒 O que você cadastrar/editar aqui fica protegido — a reimportação da planilha não sobrescreve.
          </div>

          {erro && <div style={{ marginTop: 12, fontSize: 13, color: 'var(--danger)' }}>{erro}</div>}

          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            <Button variant="default" onClick={onClose} disabled={salvando} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
            <Button variant="accent" icon="check" onClick={salvar} disabled={salvando} style={{ flex: 1.3, justifyContent: 'center' }}>{salvando ? 'Salvando…' : (editar ? 'Salvar' : 'Cadastrar')}</Button>
          </div>
        </div>
      </div>
    </div>
  ), document.body);
}

/* Vínculo MANUAL de uma empresa a um contrato já existente. Caso típico: filial
   nova que abre e é coberta pelo mesmo contrato, sem gerar aditivo. Marca a
   empresa como origem='manual' — o espelho da planilha preserva esse vínculo. */
function VincularModal({ empresa, contratos, empresas, onClose, onVinculado }) {
  const [busca, setBusca] = useState('');
  const [salvando, setSalvando] = useState('');

  // sugestão: contratos já vinculados a empresas do MESMO grupo (matriz/filial)
  const sugeridos = useMemo(() => {
    const ids = new Set(empresas.filter(e => e.grupo && e.grupo === empresa.grupo && e.contrato).map(e => e.contrato.dbId));
    return contratos.filter(c => ids.has(c.dbId));
  }, [empresas, contratos, empresa]);

  const q = busca.trim().toLowerCase();
  const resultados = q.length >= 2
    ? contratos.filter(c => (c.razao || '').toLowerCase().includes(q) || (c.codigo || '').toLowerCase().includes(q)).slice(0, 12)
    : sugeridos;

  async function aplicar(contratoId) {
    setSalvando(String(contratoId));
    try { await window.Api.apiEmpresaVincular(empresa.id, contratoId); onVinculado(); }
    catch (e) { window.avisar(e.message); setSalvando(''); }
  }

  const Item = ({ c }) => (
    <button onClick={() => aplicar(c.dbId)} disabled={!!salvando} style={{ display: 'flex', alignItems: 'center', gap: 10, width: '100%', textAlign: 'left', padding: '10px 12px', border: '1px solid var(--border)', borderRadius: 'var(--r-sm)', background: 'var(--surface-2)', cursor: 'pointer' }}>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap: 5, fontSize: 11, fontWeight: 800, color: 'var(--booker-orange)', background: 'var(--warn-bg)', padding: '3px 8px', borderRadius: 99, flexShrink: 0 }} className="mono">{c.codigo}</span>
      <span style={{ flex: 1, minWidth: 0, fontSize: 13, fontWeight: 600, color: 'var(--text-strong)', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>{c.razao}</span>
      <Icon name="link" size={15} style={{ color: 'var(--text-muted)' }} />
    </button>
  );

  return ReactDOM.createPortal((
    <div onClick={salvando ? undefined : onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(20,20,22,.55)', backdropFilter: 'blur(3px)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 100, animation: 'fadeIn .2s ease both', padding: 20 }}>
      <div onClick={e => e.stopPropagation()} style={{ width: '100%', maxWidth: 520, maxHeight: '88vh', overflowY: 'auto', background: 'var(--surface)', borderRadius: 16, boxShadow: 'var(--shadow-lg)', animation: 'popIn .25s ease both' }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', padding: '18px 22px', borderBottom: '1px solid var(--border)' }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
            <Icon name="link" size={19} style={{ color: 'var(--booker-orange)' }} />
            <h3 style={{ margin: 0, fontSize: 17, fontWeight: 800, color: 'var(--text-strong)' }}>Vincular ao contrato</h3>
          </div>
          <button onClick={onClose} style={{ background: 'none', border: 'none', color: 'var(--text-muted)', padding: 4 }}><Icon name="x" size={18} /></button>
        </div>
        <div style={{ padding: 22 }}>
          <div style={{ fontSize: 13, color: 'var(--text-muted)', marginBottom: 16 }}>Empresa: <b style={{ color: 'var(--text-strong)' }}>{empresa.razao}</b> <span className="mono">· {empresa.cnpj}</span></div>

          {sugeridos.length > 0 && !q && (
            <div style={{ marginBottom: 16 }}>
              <div style={{ fontSize: 12, fontWeight: 700, color: 'var(--ok)', marginBottom: 8, display: 'flex', alignItems: 'center', gap: 6 }}><Icon name="sparkles" size={14} /> Sugerido — mesmo grupo ({empresa.grupo})</div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>{sugeridos.map(c => <Item key={c.dbId} c={c} />)}</div>
            </div>
          )}

          <label style={{ fontSize: 12, fontWeight: 700, color: 'var(--text-muted)', display: 'block', marginBottom: 6 }}>Ou busque qualquer contrato</label>
          <input autoFocus value={busca} onChange={e => setBusca(e.target.value)} placeholder="Buscar por código ou razão social…" style={{ width: '100%', padding: '11px 13px', borderRadius: 'var(--r-sm)', border: '1px solid var(--border-strong)', background: 'var(--surface-2)', color: 'var(--text-strong)', fontSize: 14, outline: 'none', marginBottom: 12 }} />
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            {q.length >= 2 && resultados.map(c => <Item key={c.dbId} c={c} />)}
            {q.length >= 2 && !resultados.length && <div style={{ fontSize: 12.5, color: 'var(--text-muted)', padding: 10 }}>Nenhum contrato encontrado.</div>}
          </div>

          <div style={{ display: 'flex', gap: 10, marginTop: 20 }}>
            <Button variant="default" onClick={onClose} style={{ flex: 1, justifyContent: 'center' }}>Cancelar</Button>
          </div>
        </div>
      </div>
    </div>
  ), document.body);
}

function Mini({ icon, tone, label, value }) {
  return (
    <Card pad={16}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 10 }}>
        <span style={{ width: 38, height: 38, borderRadius: 10, background: tone + '1c', color: tone, display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}><Icon name={icon} size={19} /></span>
        <div>
          <div className="tnum" style={{ fontSize: 22, fontWeight: 800, color: 'var(--text-strong)', lineHeight: 1 }}>{value}</div>
          <div style={{ fontSize: 12, color: 'var(--text-muted)', fontWeight: 600, marginTop: 2 }}>{label}</div>
        </div>
      </div>
    </Card>
  );
}

Object.assign(window, { Empresas });
